import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import "./publication.css";
import AddIcon from "@material-ui/icons/Add";
import WmModals from "../modals/Wm.Modals";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import Wmswitch from "../ui-components/wm-form-components/switch/Wm-switch";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import Fab from "@material-ui/core/Fab";
import CircularProgress from "@material-ui/core/CircularProgress";
import Required from "../Components/required/Required"
import { wordCountFun } from '../functions/general'
import dummy from "../assets/images/file.svg";
import Publicationcard from "./Publication.card";
import Cookies from "universal-cookie";
import { useHistory } from "react-router-dom";
import Loading from "../Loading/Loading";
import { useMutation, useQuery, useQueryClient, } from "react-query";
import { addPublication, getUserDetail } from "../functions/details";
import ServerError from "../Pages/error/500/ServerError";
const Cookie = new Cookies();
function Publication() {
  const queryClient = useQueryClient()
  var token = Cookie.get("wmtoken");
  let history = useHistory();
  const backToLoginPage = () => {history.push("/login")};
  const [publicationModal, setPublicationModal] = useState(false);
  const [publication, setPublication] = useState([]);
  const [wordCount, setWordCount] = useState(0);
  const [countBool, setCountBool] = useState(false);
  const [portfolioData, setPortfolioData] = useState({title: '', publishers: '', publication_url: '', date_of_publish: '', description: '', media_privacyBool: true, media_privacy: true,  mediaSend: '', media: dummy });
  const bioWordCount = (words) => {
    setWordCount(words.length);
    var maxLength = 150;
    if (wordCountFun(words, maxLength)) {setCountBool(true)}
    if (!wordCountFun(words, maxLength)) {setCountBool(false)}
  };
  useEffect(() => {bioWordCount(portfolioData.description)}, [])
  const fileUpload = useRef(null);
  function handleImageClick() {
    fileUpload.current.click();
  }
  const uploadImage = (e) => {
    e.persist();
    var file = e.target.files[0];
    setPortfolioData((prevData) => {
      prevData.media = URL.createObjectURL(file)
      prevData.mediaSend = file
      return { ...prevData }
    })
  };
  const reset = () => {
    setPortfolioData({title: '', publishers: '', publication_url: '', date_of_publish: '', description: '', media_privacyBool: true, media_privacy: true,  mediaSend: '', media: dummy })
  }
  const { isError, isLoading, isSuccess, error } = useQuery(['publicationData', 'PUBLICATION'], getUserDetail, { refetchOnWindowFocus: false, onSuccess: data => { setPublication(data[0]) } })
  const addPublicationData = useMutation(data => addPublication(data), {
    onMutate: async () => {
      await queryClient.cancelQueries('publicationData')
      const previousValue = queryClient.getQueryData('publicationData')
      return previousValue
    },
    onError: (previousValue) =>
      queryClient.setQueryData('publicationData', previousValue),
    onSuccess: () => {
      queryClient.invalidateQueries('publicationData')
      reset();
      setPublicationModal(false)
    },
  })
  if (isLoading) return <><div className="flex items-center justify-center"><Loading className={'w-48'} /></div></>;
  if (isError) return <><div><ServerError message={error.response.status} /></div></>
  if (isSuccess) return (
    <>
      {token ? (
        <div className="publication container-fluid mb-10 md:mb-0">
          <div className="about_head">
            <span className="block manpro font-semibold text-3xl mb-3">Publication</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {publication?.map((publicationData, idx) => {return (<Publicationcard key={idx} publicationData={publicationData}/>);})}
          </div>
          <div className="mt-10 text-center flex flex-col items-center">
            <Fab size="small" aria-label="add" className="bg-color-2 color-1 mb-2" onClick={() => setPublicationModal(true)}>
              <AddIcon />
            </Fab>
            <p className="cursor-pointer inline-block text-sm">Add New</p>
          </div>
          <WmModals show={publicationModal} onHide={() => setPublicationModal(false)} size="lg" className="edu-modal">
            <h5 className="mb-4">Add Publication Detail</h5>
            <form onSubmit={(e) => { e.preventDefault(); addPublicationData.mutate(portfolioData) }}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Publication Title <Required /></label>
                <input placeholder="Publication Title" type="text" name="title" className="wm_form_input border-bottom border-gray-300" required value={portfolioData.title} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.title = e.target.value; return { ...prevData } }) }}/>
              </div>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label"> Publication/Publisher Name <Required /></label>
                <input placeholder="Publication/Publisher Name" type="text" name="publishers" className="wm_form_input border-bottom border-gray-300" required value={portfolioData.publishers} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.publishers = e.target.value; return { ...prevData } }) }}/>
              </div>
              <Row>
                <Col md={12}>
                  <div className="wm_form_group flex flex-col mb-4">
                    <label className="wm_form_label">Publication Link/URL</label>
                    <input placeholder="Publication Link/URL" type="url" name="publication_url" className="wm_form_input border-bottom border-gray-300" value={portfolioData.publication_url} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.publication_url = e.target.value; return { ...prevData } }) }}/>
                    <div>
                      <small className='manpro text-gray-600'>Please type in the correct URL for the Publication http://example.com/</small>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="wm_form_group flex flex-col mb-4">
                    <label className="wm_form_label">Publication Date <Required /></label>
                    <input type="date" placeholder="Publication Date" name="date_of_publish" className="wm_form_input border-bottom border-gray-300" value={portfolioData.date_of_publish} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.date_of_publish = e.target.value; return { ...prevData } }) }}/>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="wm_form_group flex flex-col mb-4">
                    <label className="wm_form_label">Description</label>
                    <textarea placeholder="Description" name="description" className="wm_form_input border-bottom border-gray-300" value={portfolioData.description} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.description = e.target.value; return { ...prevData } }) }} onKeyUp={(e) => bioWordCount(e.target.value)} maxLength="150"></textarea>
                    <small className={`mt-2 ${countBool ? "text-red-500" : "text-gray-400"}`}>{wordCount}/150</small>
                  </div>
                </Col>
                <Col md={7}>
                  <div className="wm_form_group flex mb-4 items-center">
                    <div className="flex flex-col mr-4">
                      <label className="wm_form_label">Media</label>
                      <input type="file" className="hidden" onChange={(e) => uploadImage(e)} ref={fileUpload} accept="image/png, image/jpeg, image/jpg"/>
                      <div onClick={handleImageClick} className="fileImageWrapper w-40 h-28 flex justify-center items-center rounded-xl border-gray-300 border-2 border-dashed cursor-pointer overflow-hidden">
                        <img className="object-cover" src={portfolioData.media} alt="education"/>
                      </div>
                    </div>
                    <Tooltip title={<React.Fragment>This media will be displayed in public profile And you can toggle to switch off the visibility</React.Fragment>} placement="right"><HelpIcon /></Tooltip>
                  </div>
                </Col>
                <Col md={5}>
                  <div className="wm_form_group flex flex-col mb-4">
                    <label className="wm_form_label">Show Media</label>
                    <Wmswitch color="success" checked={portfolioData.media_privacy} onChange={() => setPortfolioData((prevData) => { prevData.media_privacy = !portfolioData.media_privacy; return { ...prevData } })}/>
                  </div>
                </Col>
              </Row>
              <div className="wm_form_group">
                <Wmbutton label={addPublicationData.isLoading ? (<CircularProgress className="loader_size_xsm" />) : ("Save")} bordered className="rounded w-20 mr-2" type="submit" color="primary-border"/>
                <Wmbutton label="Cancel" onClick={() => { setPublicationModal(false); reset() }} className="rounded w-20" type="button" color="primary"/>
              </div>
            </form>
          </WmModals>
        </div>
      ) : (
        backToLoginPage()
      )}
    </>
  );
}

export default Publication;
